var _style, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAdicionar01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.1,
    className: "st0",
    width: 35.8,
    height: 35.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3,5.5c-6.9-6.8-18-6.7-24.8,0.2c-6.8,6.9-6.7,18,0.2,24.8c6.9,6.8,18,6.7,24.8-0.2C37.3,23.4,37.2,12.3,30.3,5.5z  M27.8,19.9h-7.9v7.9h-3.8v-7.9H8.2v-3.8h7.9V8.2h3.8v7.9h7.9V19.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAdicionar01);
export default __webpack_public_path__ + "static/media/ico-adicionar-01.37a4bb78775aaf37443cdb89124f8a3d.svg";
export { ForwardRef as ReactComponent };